import React from 'react';
import { SocialNetwork } from '@actus/types';
import { SquareSvgProps } from '@icons/icon.types';
import { useTranslation } from '@locales/useTranslation.hook';

function LinkedinLogoIcon({ title, fillColor = '#2D3049', size = 24, ...props }: SquareSvgProps) {
  const { t } = useTranslation(['common']);
  return (
    <svg height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || t('common.share', { socialNetworkName: SocialNetwork.Linkedin })}</title>
      <path
        d="M18.848 18.743h-3.001V13.91c0-1.214-.435-2.042-1.52-2.042-.83 0-1.324.559-1.541 1.098-.08.192-.099.462-.099.733v5.043H9.685s.04-8.184 0-9.03h3.002v1.278c.4-.616 1.112-1.492 2.706-1.492 1.975 0 3.456 1.291 3.456 4.065v5.18zM6.523 8.478h-.02c-1.007 0-1.658-.694-1.658-1.56 0-.886.671-1.56 1.698-1.56s1.659.674 1.679 1.56c0 .866-.652 1.56-1.699 1.56zm-1.5 10.265h3.001V9.712H5.022v9.03zM20.52 2H3.477C2.662 2 2 2.641 2 3.433v17.135C2 21.358 2.662 22 3.477 22h17.044c.817 0 1.479-.642 1.479-1.432V3.433C22 2.64 21.338 2 20.521 2z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { LinkedinLogoIcon };
